module.exports = __webpack_public_path__ + "static/media/26UNRWA24.d54e912a.jpg";